import { render } from "./SectionMenu.vue?vue&type=template&id=49c0d38b"
import script from "./SectionMenu.vue?vue&type=script&lang=js"
export * from "./SectionMenu.vue?vue&type=script&lang=js"

import "./SectionMenu.vue?vue&type=style&index=0&id=49c0d38b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__